import React from 'react'

import PaginationCard from './Components/PaginationCard'
import PaginationLinks from './Components/PaginationLinks'
import PerPage from './Components/PerPage'
import NumberOfItems from './Components/NumberOfItems'

function Pagination() {
  return (
    <div className="col-12">
      <div className="metaverse-pagination-new">
        <NumberOfItems />
        <PaginationCard />
        <PerPage />
      </div>
      <PaginationLinks />
    </div>
  )
}

export default Pagination
